import { render, staticRenderFns } from "./ComponentForm.vue?vue&type=template&id=7bd54af4&"
import script from "./ComponentForm.vue?vue&type=script&lang=js&"
export * from "./ComponentForm.vue?vue&type=script&lang=js&"
import style0 from "./ComponentForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bd54af4')) {
      api.createRecord('7bd54af4', component.options)
    } else {
      api.reload('7bd54af4', component.options)
    }
    module.hot.accept("./ComponentForm.vue?vue&type=template&id=7bd54af4&", function () {
      api.rerender('7bd54af4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ComponentForm.vue"
export default component.exports